import {bindable } from 'aurelia-framework';
import moment from 'moment';

export class TrialTimeline {
  @bindable subscriptionType;

  constructor() {

    this.nextDate1 = moment().add(7,'days')
    this.nextDate2 = moment().add(12,'days')
    this.nextDate3 = moment().add(13,'days')
    this.nextDate4 = moment().add(14,'days')

  }

  attached() {

  }

  activate(){

  }

}
